<template>
  <div>
    <van-popup
      v-model="isShow"
      round
      position="bottom"
      :lock-scroll="true"
      closeable
      close-icon="close"
      class="AddChildren"
      :close-on-popstate="true"
      :style="{
        width: '100%',
      }"
    >
      <h3>请选择成人证件为随行儿童购票</h3>
      <van-row
        type="flex"
        class="adult-box"
      >
        <van-col
          class="adult-box__item"
          v-for="(psg, i) in adultList"
          :key="i"
          @click="$emit('selected', psg, i)"
          :span="24 / adultList.length"
        >
          <h3>{{ psg | getName }}</h3>
          尾号 
          <span v-if="!psg.cardType || psg.cardType == '1'">
            {{ psg.idNo || psg.idNumber || psg.identy | lastThree }}
          </span>
          <span v-else-if="psg.cardType == 'B'">
            {{ psg.passport | lastThree }}
          </span>
          <span v-else-if="psg.cardType">
            {{ psg.otherNumber | lastThree }}
          </span>
        </van-col>
      </van-row>

      <div class="addYrDesc">
        <ul>
          <li>· 儿童身高>1.5m，需买成人票，全价</li>
          <li>· 儿童身高1.2m-1.5m，可买儿童票，享儿童票优惠价</li>
          <li>· 儿童身高<v-text="'<1.2m'"/>，不需要购票，免费</li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'

export default {
  name: 'AddChildren',
  components: {
    [Popup.name]: Popup
  },
  props: {
    travelerList: {//需要展示的出行人
      type: [Array, Object],
      required: true,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      isShow: false,
    }
  },
  computed: {
    adultList () {
      return this.travelerList.filter(travel => travel.psgType != 2)
    }
  },
  methods: {
    toggle () {
      this.isShow = !this.isShow
    }
  },
  filters: {
    lastThree (str) {
      if (str) {
        return str.substring(str.length - 3, str.length + 1)
      }
    }
  }
}
</script>

<style lang="less">
.AddChildren {
  padding: 12px;

  h3 {
    margin: 5px 0;
  }

  .adult-box {
    margin: 10px 0;

    .adult-box__item {
      text-align: center;
      margin-right: 10px;
      padding: 2px 8px;
      border: 1px solid;
      border-radius: @border-radius-sm;
      color: @color-text-main;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  
  .addYrDesc {
    padding: 10px;
    border-radius: 4px;
    background-color: @color-background-gray;
  }
  .addYrDesc li {
    margin: 8px 0;
  }
}
</style>